// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3xbG1","sendOtp":"AuthorizeToLogin_sendOtp__aZlh_"};